import { ValidationData } from "@/app/validators/Validator";

export class DataValidationError {
  data: ValidationData;

  constructor(data: ValidationData) {
    this.data = data;
  }
}
